import React, { SyntheticEvent } from "react";
import { Checkbox, Form, Label } from "semantic-ui-react";

const CallableToggle = ({
  field,
  form: { errors, touched, setFieldValue },
  label,
  inline,
  ...props
}: any) => {
  return (
    <Form.Field>
      {label && <label>{label}</label>}
      <br />

      <Checkbox
        defaultChecked={field.value}
        onChange={(event: SyntheticEvent, data: any) => {
          setFieldValue(field.name, data.checked);
        }}
        name={field.name}
        // checked={field.value}
        {...props}
      />
      {touched[field.name] && errors[field.name] && (
        <Label basic pointing='left' color='red'>
          {errors[field.name]}
        </Label>
      )}
    </Form.Field>
  );
};

export default CallableToggle;
